
import axios, { AxiosResponse, AxiosError } from 'axios';

export default class AuthFreeService {

    static async sendMail(data: any): Promise<AxiosResponse> {
        try {
            const response = await axios.post(
                process.env.NODE_ENV === 'production' ? `https://letsroll.site/api/support` : `http://localhost:5000/api/support`,
                data,
                {
                    withCredentials: true,
                }
            );
            return response;
        } catch (error: any) { // Type 'error' as 'any' or 'AxiosError'
            if (axios.isAxiosError(error)) {
                // If it's an Axios error, throw the error object itself
                throw error;
            } else {
                // If it's a generic error, throw a new error with a message
                throw new Error("Error sending email");
            }
        }
    }
}